import styled from 'styled-components';

/** Fixed footprint so ToggleButton hover expansion does not reflow wrapped table rows. */
export const ToggleButtonAnchor = styled.span<{ $expandLeft?: boolean }>`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: 25px;
  height: 26px;
  vertical-align: middle;
  overflow: visible;

  > button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    ${({ $expandLeft }) =>
      $expandLeft
        ? `
      right: 0;
      left: auto;
    `
        : `
      left: 0;
      right: auto;
    `}

    &:hover {
      z-index: 10;
    }
  }
`;
